export default __webpack_public_path__ + "static/media/prologue-cat-negative.70f57a73.png";